import { ref, computed, reactive } from '@vue/composition-api'

export default function useTemplateList(ctx) {
  const tableColumns = [
    { key: 'name' },
    { key: 'effectiveDateTime', label: 'Effective Date' },
    { key: 'updatedAt', label: 'Updated At' },
    { key: 'Actions' },
  ]
  const queryParams = reactive({
    size: 10,
    page: 1,
    name: undefined,
  })
  const getTemplateList = computed(() => ctx.root.$store.getters['templates/getTemplateList'])
  const templatesLoading = ref(false)
  const servicesByZone = ref({})
  const fetchTemplates = async () => {
    try {
      templatesLoading.value = true
      if (!queryParams.name) {
        queryParams.name = undefined
      }
      await ctx.root.$store.dispatch('templates/fetchTemplates', queryParams)
      servicesByZone.value = await ctx.root.$store.dispatch('zones/fetchZoneByServicesCached')
    } catch (error) {
      console.log(error)
    } finally {
      templatesLoading.value = false
    }
  }

  fetchTemplates()

  return {
    tableColumns,
    templatesLoading,
    fetchTemplates,
    getTemplateList,
    queryParams,
    servicesByZone,
  }
}
